import { NgModule } from '@angular/core';

import { AppSharedApplicationAdapter } from 'application/common/app-shared-application.adapter';
import { AppSharedApplicationPort } from 'application/common/port/app-shared-application.port';
import { MessageApplicationAdapter } from 'application/message/message-application.adapter';
import { MessageConverterAdapter } from 'application/message/message-converter.adapter';
import { MessageApplicationPort } from 'application/message/port/message-application.port';
import { MessageConverterPort } from 'application/message/port/message-converter.port';
import { NotificationApplicationAdapter } from 'application/notification/notification-application.adapter';
import { NotificationApplicationPort } from 'application/notification/port/notification-application.port';
import { CvTemplateApplicationAdapter } from 'application/template/cv/cv-template-application.adapter';
import { CvTemplateConverterAdapter } from 'application/template/cv/cv-template-converter.adapter';
import { CvTemplateApplicationPort } from 'application/template/cv/port/cv-template-application.port';
import { CvTemplateConverterPort } from 'application/template/cv/port/cv-template-converter.port';
import { ArticleConverterAdapter } from 'article/article-converter.adapter';
import { ArticleConverterPort } from 'article/port/article-converter.port';
import { ContactApplicationAdapter } from 'contact/contact-application.adapter';
import { ContactConverterAdapter } from 'contact/contact-converter.adapter';
import { ContactApplicationPort } from 'contact/port/contact-application.port';
import { ContactConverterPort } from 'contact/port/contact-converter.port';
import { DocumentApplicationAdapter } from 'document/document-application.adapter';
import { DocumentConverterAdapter } from 'document/document-converter.adapter';
import { DocumentApplicationPort } from 'document/port/document-application.port';
import { DocumentConverterPort } from 'document/port/document-converter.port';
import { JobOfferApplicationAdapter } from 'job/job-offer-application.adapter';
import { JobOfferConverterAdapter } from 'job/job-offer-converter.adapter';
import { JobOfferApplicationPort } from 'job/port/job-offer-application.port';
import { JobOfferConverterPort } from 'job/port/job-offer-converter.port';
import { ModuleApplicationAdapter } from 'module/module-application.adapter';
import { ModuleGraphConverterAdapter } from 'module/page/graph/module-graph-converter.adapter';
import { ModuleGraphConverterPort } from 'module/page/graph/port/module-graph-converter.port';
import { ModulePageConverterAdapter } from 'module/page/module-page-converter.adapter';
import { ModulePageConverterPort } from 'module/page/port/module-page-converter.port';
import { ModuleQuestionConverterAdapter } from 'module/page/question/module-question-converter.adapter';
import { ModuleQuestionConverterPort } from 'module/page/question/port/module-question-converter.port';
import { ModuleTaskConverterAdapter } from 'module/page/task/module-task-converter.adapter';
import { ModuleTaskConverterPort } from 'module/page/task/port/module-task-converter.port';
import { ModuleApplicationPort } from 'module/port/module-application.port';
import { ModuleConverterPort } from 'module/port/module-converter.port';
import { OrganizationConverterAdapter } from 'organization/organization-converter.adapter';
import { OrganizationConverterPort } from 'organization/port/organization-converter.port';
import { OrganizationPropertiesConverterAdapter } from 'organization/property/organization-properties-converter.adapter';
import { OrganizationPropertiesConverterPort } from 'organization/property/port/organization-properties-converter.port';
import { PhaseApplicationAdapter } from 'phase/phase-application.adapter';
import { PhaseConverterAdapter } from 'phase/phase-converter.adapter';
import { PhaseApplicationPort } from 'phase/port/phase-application.port';
import { PhaseConverterPort } from 'phase/port/phase-converter.port';
import { SectionConverterPort } from 'phase/section/port/section-converter.port';
import { SectionConverterAdapter } from 'phase/section/section-converter.adapter';
import { ModuleConverterAdapter } from 'src/app/application/module/module-converter.adapter';
import { TaskApplicationPort } from 'task/port/task-application.port';
import { TaskConverterPort } from 'task/port/task-converter.port';
import { TaskApplicationAdapter } from 'task/task-application.adapter';
import { TaskConverterAdapter } from 'task/task-converter.adapter';
import { UserContactCompanyApplicationPort } from 'user/port/contact/user-contact-company-application.port';
import { UserMoodApplicationPort } from 'user/port/mood/user-mood-application.port';
import { UserApplicationPort } from 'user/port/user-application.port';
import { UserApplicationAdapter } from 'user/user-application.adapter';
import { UserContactCompanyApplicationAdapter } from 'user/user-contact-company-application.adapter';
import { UserMoodApplicationAdapter } from 'user/user-mood-application.adapter';

@NgModule({
	providers: [
		{
			provide: UserContactCompanyApplicationPort,
			useClass: UserContactCompanyApplicationAdapter,
		},
		{
			provide: UserMoodApplicationPort,
			useClass: UserMoodApplicationAdapter,
		},
		{
			provide: ContactConverterPort,
			useClass: ContactConverterAdapter,
		},
		{
			provide: TaskConverterPort,
			useClass: TaskConverterAdapter,
		},
		{
			provide: DocumentConverterPort,
			useClass: DocumentConverterAdapter,
		},
		{
			provide: OrganizationConverterPort,
			useClass: OrganizationConverterAdapter,
		},
		{
			provide: OrganizationPropertiesConverterPort,
			useClass: OrganizationPropertiesConverterAdapter,
		},
		{
			provide: PhaseConverterPort,
			useClass: PhaseConverterAdapter,
		},
		{
			provide: SectionConverterPort,
			useClass: SectionConverterAdapter,
		},
		{
			provide: ModuleConverterPort,
			useClass: ModuleConverterAdapter,
		},
		{
			provide: ModulePageConverterPort,
			useClass: ModulePageConverterAdapter,
		},
		{
			provide: ModuleGraphConverterPort,
			useClass: ModuleGraphConverterAdapter,
		},
		{
			provide: ModuleQuestionConverterPort,
			useClass: ModuleQuestionConverterAdapter,
		},
		{
			provide: ModuleTaskConverterPort,
			useClass: ModuleTaskConverterAdapter,
		},
		{
			provide: MessageConverterPort,
			useClass: MessageConverterAdapter,
		},
		{
			provide: JobOfferConverterPort,
			useClass: JobOfferConverterAdapter,
		},
		{
			provide: ArticleConverterPort,
			useClass: ArticleConverterAdapter,
		},
		{
			provide: NotificationApplicationPort,
			useClass: NotificationApplicationAdapter,
		},
		{
			provide: AppSharedApplicationPort,
			useClass: AppSharedApplicationAdapter,
		},
		{ provide: JobOfferApplicationPort, useClass: JobOfferApplicationAdapter },
		{ provide: DocumentApplicationPort, useClass: DocumentApplicationAdapter },
		{ provide: ContactApplicationPort, useClass: ContactApplicationAdapter },
		{ provide: MessageApplicationPort, useClass: MessageApplicationAdapter },
		{ provide: ModuleApplicationPort, useClass: ModuleApplicationAdapter },
		{ provide: PhaseApplicationPort, useClass: PhaseApplicationAdapter },
		{ provide: UserApplicationPort, useClass: UserApplicationAdapter },
		{ provide: TaskApplicationPort, useClass: TaskApplicationAdapter },
		{
			provide: CvTemplateApplicationPort,
			useClass: CvTemplateApplicationAdapter,
		},
		{
			provide: CvTemplateConverterPort,
			useClass: CvTemplateConverterAdapter,
		},
	],
})
export class AppServiceModule {}
